import React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';

import {useComponent} from './hooks';

import './SearchIcon.less';

function SearchIcon(props) {
    const {
        className,
        markup
    } = useComponent(props);

    return (
        <SVGIcon
            className={className}
            markup={markup}
        />
    );
}

SearchIcon.propTypes = {
    name: PropTypes.string.isRequired
};

export {SearchIcon};
